import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import Typography from '../Typography';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';
import Select from '../Select/Select';
import InputRange from '../Input/InputRange';
import InputLocation from '../Input/InputLocation';
import GooglePlacesAutocomplete from '../GooglePlacesAutocomplete';

const LocationTimeComboFiltersModal = ({
  tempLocationFilters,
  handleLocationTimeChange,
  handleCancelLocationTime,
  handleApplyLocationTime,
  handleCloseLocationTimeModal,
  autocompleteRef,
  inputRef,
  handlePlaceSelect,
  minRadius,
  maxRadius,
  tFilter,
  setTempLocationFilters
}) => {
  return (
    <Modal
      title={tFilter('modalLocationTime.title')}
      onClose={handleCloseLocationTimeModal}
      maxWidth="500px"
    >
      <LocationModalContent>
        {/* locationFilters */}
        <LocationSection>
          <LocationAddressBlock>
            <Typography as="label" $variant="body-3-semibold" color={theme.colors.defaultStrong}>
              {tFilter('locationFilters.location.label')}
            </Typography>

            <GooglePlacesAutocomplete
              onLoad={(autocomplete) => {
                autocompleteRef.current = autocomplete;
              }}
              onPlaceChanged={handlePlaceSelect}
            >
              <InputLocation
                ref={inputRef}
                type="text"
                value={tempLocationFilters.address}
                onChange={(e) => setTempLocationFilters(prev => ({ ...prev, address: e.target.value }))}
                placeholder={tFilter('locationFilters.location.placeholder')}
                id="locationInput"
                size=""
                variant="default"
              />
            </GooglePlacesAutocomplete>
          </LocationAddressBlock>
          <LocationRadiusBlock>
            <Typography htmlFor="radiusRange" as="label" $variant="body-3-semibold" color={theme.colors.defaultStrong}>
              {tFilter('locationFilters.radius.label')}
            </Typography>
            <InputRange
              min={minRadius}
              max={maxRadius}
              step={10}
              value={tempLocationFilters.radius}
              onChange={(e) => handleLocationTimeChange('radius', e.target.value)}
              label={tFilter('locationFilters.radius.label')}
            />
          </LocationRadiusBlock>
        </LocationSection>

        {/* Time Frame Section */}
        <TimeFrameSection>
          <Typography as="label" $variant="body-3-semibold" color={theme.colors.defaultStrong}>
            {tFilter('timeFilters.time.label')}
          </Typography>
          <TimeFrame
            $size=""
            value={tempLocationFilters.timeFilter}
            onChange={(e) => handleLocationTimeChange('timeFilter', e.target.value)}
          >
            <option value="flexible">{tFilter('timeFilters.time.flexible')}</option>
            <option value="today">{tFilter('timeFilters.time.today')}</option>
            <option value="tomorrow">{tFilter('timeFilters.time.tomorrow')}</option>
            <option value="this_week">{tFilter('timeFilters.time.this_week')}</option>
            <option value="this_month">{tFilter('timeFilters.time.this_month')}</option>
          </TimeFrame>
        </TimeFrameSection>
      </LocationModalContent>
      {/* Action Buttons */}
      <ModalActions>
        <ModalAction $variant="outline" onClick={handleCancelLocationTime} size="l">
          {tFilter('modalLocationTime.cancel')}
        </ModalAction>
        <ModalAction onClick={handleApplyLocationTime} size="l">
          {tFilter('modalLocationTime.apply')}
        </ModalAction>
      </ModalActions>
    </Modal>
  );
};

export default LocationTimeComboFiltersModal;

// Estilos
const LocationModalContent = styled.div`
  padding: ${({ theme }) => theme.sizing.sm};
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.sizing.sm};
`;

const LocationSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
`;

const LocationAddressBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xxs};
`;

const LocationRadiusBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xxs};
`;

const TimeFrameSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xxs};
`;

const ModalActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.sm};
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;
  max-width: 100%;
  border-top: 1px solid ${({ theme }) => theme.border.defaultSubtle};
`;

const ModalAction = styled(Button)`
  flex-grow: 1;
`;

const TimeFrame = styled(Select)`
  font-weight: 500;
  // padding: 12px;
  // border-radius: 8px;
  // border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  // width: 100%;
`;
